<script>
import OrderAPI from "@/services/orders-api";
import Swal from "sweetalert2";
import QuantityControl from "@/components/QuantityControl.vue"
import VSelectWithValidation from "@/components/VSelectWithValidation.vue"
import Receipt from "@/components/Receipt.vue"
import ArchivedOrderAPI from "@/services/archivedOrders-api";

export default {
    components: {QuantityControl, VSelectWithValidation, Receipt},
    props : {
      tableNumber:{
        type:Number,
        default:null,
      },
      orderTableId:{
        type:Number,
        default:null,
      },
      menuItems:{
        type:Array,
        default:() => null,
      },
      isMobile:{
        type:Boolean,
        default:false,
      },
      isArchivedOrder:{
        type:Boolean,
        default:false,
      },
    },


  data() {
    return {
      order:null,
      loadingOrder:false,
      lineEditingQuantityId: null,
      showMenuItmesList:false,
      selectedItem:null,
      expandedItemId: null,
      showReceiptModal: false,
      showEditTableNumber: false,
      targetTable:null,
      errorMessage:null,

      ACTIONS_STATUS: {
        CALL_WAITER: 1,
        VIEWED: 2,
        ARCHIVED: 3,
        CANCEL: 4,
      }
  

    };
  },
  mounted() {
    this.getOrderTablesDetails()  
  },

  watch:{
    tableNumber: function(){
      this.getOrderTablesDetails();
      if(this.tableNumber && this.tableNumber){
        this.targetTable= this.tableNumber
      }

    }
  
  },

  computed: {
    submittedItems() {
      return this.order &&
            this.order.lines &&
            this.order.lines.submitted
            ? this.order.lines.submitted
            : null;
    },

  submittedViewedItems() {
    return this.submittedItems && this.submittedItems.items
      ? this.submittedItems.items.filter(item => item.isViewed === true)
      : [];
  },

  submittedUnviewedItems() {
    return this.submittedItems && this.submittedItems.items
      ? this.submittedItems.items.filter(item => item.isViewed === false)
      : [];
  },

    hasNoSubmittedItems() {
      return (
        !this.submittedItems ||
        !this.submittedItems.items ||
        this.submittedItems.items.length === 0
      );
    },

    isOnlineOrder() {
      return this.tableNumber > 100000;
    }

  },


  methods: {

    saveTableTransfer(){
      OrderAPI.saveTableTransfer(this.order.id, this.targetTable).then((result) =>{
            this.order = result;
            this.loadingOrder = false
            this.showEditTableNumber = false
            this.refresh();
        })
        .catch((error) => {
            this.loadingOrder = false;
            const DEFAULT_ERROR = "Mauvaise requete";

            this.errorMessage = error.includes(DEFAULT_ERROR) ? null : error;

            if (this.errorMessage) {
                setTimeout(() => {
                    this.errorMessage = null;
                }, 3000);
            }

            this.showEditTableNumber = false;
        })
        .finally(()=>{
            this.loadingOrder = false
      });
    },

    increaseTable() {
    this.targetTable++;
    },
    decreaseTable() {
    if (this.targetTable > 1) {
      this.targetTable--;
      }
    },

    editTableNumber(){
      if(this.tableNumber){
         this.targetTable= this.tableNumber.tableNumber
      }
      this.showEditTableNumber= !this.showEditTableNumber
    },

    toggleExpand(id) {
      this.expandedItemId = this.expandedItemId === id ? null : id;
    },

    handleItemSelected(itemId){
     this.addOrderline(itemId)
    },

    displayMenuItemsList(){
      this.showMenuItmesList = !this.showMenuItmesList
    },

    handleQuantityChange(qte, item) {
      if (qte === 0) {
        this.$swal({
          title: this.$t("menuOrder.cart.swal.removeItemTitle", { name: item.name }),
          text: this.$t("menuOrder.cart.swal.removeItemText"),   
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d11010",
          cancelButtonColor: "#34c38f",
          confirmButtonText: this.$t("menuOrder.cart.swal.confirm"),
          cancelButtonText: this.$t("menuOrder.cart.swal.cancel"), 
        }).then((result) => {
          if (result.isConfirmed) {
            this.updateOrderLine(qte, item.orderLineId, "Suppression de l'article" , item.name);
          }
        });
        return;
      }

      this.updateOrderLine(qte, item.orderLineId, "Modification de quantité de l'article" , item.name );
    },
    updateOrderLine(qte, orderLineId, title , itemName) {
      Swal.fire({
        title,
        html: `

          <p class="swal-item-name">
            ${itemName}
          </p>

          <p class="swal-desc">
            Pour continuer, veuillez entrer votre <strong>code de validation</strong>.
          </p>

          <input id="masked-code" type="text" 
                placeholder="••••••" 
                style="
                  font-size:1.4rem;
                  text-align:center;
                  padding:12px;
                  width:100%;
                  margin-top:0px;
                  -webkit-text-security: disc;
                  border-radius:8px;
                  border:1px solid #ddd;
                  box-shadow: 0 2px 6px rgba(0,0,0,0.08);
                  transition: border 0.2s, box-shadow 0.2s;
                  outline: none; 
                  margin-bottom: 15px;
                "
                onfocus="this.style.border='1px solid #000'; this.style.boxShadow='0 4px 10px rgba(0,0,0,0.15)'"
                onblur="this.style.border='1px solid #ddd'; this.style.boxShadow='0 2px 6px rgba(0,0,0,0.08)'"
          >


        `,
        confirmButtonText: "Valider",
        cancelButtonText: "Annuler",
        showCancelButton: true,
        allowOutsideClick: false,
        showLoaderOnConfirm: true,
        customClass: {
          popup: "swal-modern-popup",
          title: "swal-modern-title",
          htmlContainer: "swal-modern-html",
          confirmButton: "swal-btn-confirm",
          cancelButton: "swal-btn-cancel"
        },
        preConfirm: () => {
          const code = document.getElementById("masked-code").value.trim();
          if (!code) {
            Swal.showValidationMessage("Veuillez entrer un code valide");
            return false;
          }
          return code;
        }
      }).then(async ({ isConfirmed, value: code }) => {
        if (!isConfirmed) return;

        this.loadingOrder = true;
        Swal.showLoading();

        try {
          const res = await OrderAPI.editOrderline(qte, orderLineId, code);
          this.order = res;

          Swal.fire({
            icon: "success",
            title: "Succès",
            text: "La modification a été effectuée.",
            timer: 1600,
            showConfirmButton: false
          });
        } catch (err) {
          Swal.fire({
            icon: "error",
            title: "Erreur",
            text: "Impossible de modifier l'article."
          });
        } finally {
          this.loadingOrder = false;
        }
      });
    },

    

      addOrderline(menuItemId,) {
      Swal.fire({
        title :"Ajouter un article",
        html: `
          <p class="swal-desc">
            Pour continuer, veuillez entrer votre <strong>code de validation</strong>.
          </p>

          <input id="add-masked-code" type="text" 
                placeholder="••••••" 
                style="
                  font-size:1.4rem;
                  text-align:center;
                  padding:12px;
                  width:100%;
                  margin-top:0px;
                  -webkit-text-security: disc;
                  border-radius:8px;
                  border:1px solid #ddd;
                  box-shadow: 0 2px 6px rgba(0,0,0,0.08);
                  transition: border 0.2s, box-shadow 0.2s;
                  outline: none; 
                  margin-bottom: 15px;
                "
                onfocus="this.style.border='1px solid #000'; this.style.boxShadow='0 4px 10px rgba(0,0,0,0.15)'"
                onblur="this.style.border='1px solid #ddd'; this.style.boxShadow='0 2px 6px rgba(0,0,0,0.08)'"
          >


        `,
        confirmButtonText: "Valider",
        cancelButtonText: "Annuler",
        showCancelButton: true,
        allowOutsideClick: false,
        showLoaderOnConfirm: true,
        customClass: {
          popup: "swal-modern-popup",
          title: "swal-modern-title",
          htmlContainer: "swal-modern-html",
          confirmButton: "swal-btn-confirm",
          cancelButton: "swal-btn-cancel"
        },
        preConfirm: () => {
          const code = document.getElementById("add-masked-code").value.trim();
          if (!code) {
            Swal.showValidationMessage("Veuillez entrer un code valide");
            return false;
          }
          return code;
        }
      }).then(async ({ isConfirmed, value: code }) => {
        if (!isConfirmed) return;

        this.loadingOrder = true;
        Swal.showLoading();

        try {
          const res = await OrderAPI.addOrderline(menuItemId, this.order.menuCode, this.tableNumber, code );
          this.order = res;

          Swal.fire({
            icon: "success",
            title: "Succès",
            text: "L'article a été ajouté.",
            timer: 1600,
            showConfirmButton: false
          });
        } catch (err) {
          Swal.fire({
            icon: "error",
            title: "Erreur",
            text: "Impossible d'ajouter l'article."
          });
        } finally {
          this.loadingOrder = false;
        }
      });
    },


    editingQuantity(orderLineId){
      this.lineEditingQuantityId = orderLineId
    },

    cancelEditingQuantity(){
      this.lineEditingQuantityId = null
    },

    updateQuantity(item) {
      console.log(item)
    },

    cancel(){
      this.$emit("cancel");
    },

    refresh(){
      this.$emit("refresh");
    },

      updateStatus(action) {
        const isArchive = action === this.ACTIONS_STATUS.ARCHIVED;
        const isCancel = action === this.ACTIONS_STATUS.CANCEL;

        if (isArchive || isCancel) {
          Swal.fire({
            icon: "warning",
            title: `<span style="font-weight:bold; font-size: 22px;" class="text-uppercase text-dark mb-4">` + (isArchive
              ? this.$t("menuOrder.order.confirmArchiveTitle")
              : this.$t("menuOrder.order.confirmCancelTitle") ) + `</span>`,
            html: isArchive
              ? `${this.$t("menuOrder.order.confirmArchiveText")}`
              : `${this.$t("menuOrder.order.confirmCancelText")}`,
            showCancelButton: true,
            confirmButtonText: this.$t("menuOrder.order.button.confirm"),
            cancelButtonText: this.$t("menuOrder.order.button.No"),
            confirmButtonColor: "#d33",
            cancelButtonColor: "#6c757d",
            reverseButtons: true
          }).then((result) => {
            if (result.isConfirmed) {
              this._performUpdateStatus(action);
            }
          });
        } else {
          this._performUpdateStatus(action);
        }
      },

      _performUpdateStatus(action) {
        OrderAPI.updateStatus(this.orderTableId, action).then((result) => {
          if (action === this.ACTIONS_STATUS.ARCHIVED || action === this.ACTIONS_STATUS.CANCEL) {
            this.cancel();

            Swal.fire({
              icon: action === this.ACTIONS_STATUS.ARCHIVED ? "success" : "info",
              title: action === this.ACTIONS_STATUS.ARCHIVED
                ? this.$t("menuOrder.order.archivedTitle")
                : this.$t("menuOrder.order.cancelledTitle"),
              html: `<strong>${
                action === this.ACTIONS_STATUS.ARCHIVED
                  ? this.$t("menuOrder.order.archivedSuccessMessage")
                  : this.$t("menuOrder.order.cancelledSuccessMessage")
              }</strong>`,
              showConfirmButton: false,
              timer: 2500,
            });

          } else {
            this.order = result;
          }

          this.refresh();
        });
      },


    refreshDetails() {
      this.getOrderTablesDetails();
    },


    getOrderTablesDetails(){
      this.loadingOrder = true

      if(this.tableNumber == null || this.orderTableId == null){
        this.order = null
        this.loadingOrder = false
        return
      }

      const api = this.isArchivedOrder ? ArchivedOrderAPI :  OrderAPI;
      api.getOrder(this.orderTableId).then((result) =>{
        if (
          !this.order ||
          (!this.order.lastEditDateMs && result.lastEditDateMs) ||
          (!this.order.id != result.id) ||
          (this.order.lastEditDateMs &&( result.lastEditDateMs > this.order.lastEditDateMs))
        ) {
          this.order = result;
          this.loadingOrder = false
        }
      })
      .catch(() => {
          this.loadingOrder = false
      })
      .finally(()=>{
          this.loadingOrder = false
      });
    },

    




  },
};
</script>
<template>     
  <div v-if="order"> 
    <div>
      <span class="font-size-18 text-uppercase font-weight-bold text-dark"> {{ isOnlineOrder ? 'Commande en ligne' : 'Table N° ' +((order && order.tableNumber ) ? order.tableNumber : '') }}
      
      </span>
      <div class="row float-right">
        <div class="col-6" v-if="!isArchivedOrder">
            <span v-if="!isOnlineOrder"> 
              <img alt="transfer" @click="editTableNumber" title="Transférer vers une autre table" class="ml-2 float-right" width="25px" src="@/assets/icons/transfer.svg" style="cursor: pointer;"  />
            </span>
        </div>
        <div class="col-6">
            <img class="float-right" src="@/assets/icons/close-dark.svg" height="25" @click="cancel()" style="cursor: pointer;"  />
        </div>
      </div>
    </div>

    <div class="text-danger" v-if="errorMessage">
      {{ errorMessage }}
    </div>

    <div
        v-if="showEditTableNumber && !isArchivedOrder"
        class="transfer-card mt-3 p-3"
      >
        <div class="d-flex align-items-center mb-3">
          <i class="fas fa-random text-primary mr-2"></i>
          <span class="font-weight-bold">
            Transférer vers une autre table
          </span>
        </div>

        <div class="d-flex align-items-center justify-content-between mb-3">
          <button class="step-btn" @click="decreaseTable" type="button">
            <i class="fas fa-minus"></i>
          </button>

          <b-form-input
            v-model.number="targetTable"
            type="number"
            min="1"
            class="transfer-input text-center mx-2"
            placeholder="Numéro de la table"
          ></b-form-input>

          <button class="step-btn" @click="increaseTable" type="button">
            <i class="fas fa-plus"></i>
          </button>
        </div>

        <b-button
          variant="primary"
          block
          size="lg"
          @click="saveTableTransfer"
          :disabled="!targetTable"
        >
          <i class="fas fa-check mr-2"></i>
          Confirmer le transfert
        </b-button>
      </div>

    <div class="row mt-3 mb-3" v-if="order && (order.name || order.phone || order.address)">
      <div class="col-7">
        <span class="text-dark font-size-14"> {{order.name}} </span>
      </div>
      <div class="col-5 text-right">
        <span class="text-dark font-size-14"> {{order.phone}} </span>
      </div>
        <div class="col-12">
          {{order.address}}
        </div>
    </div>


      <div v-if="loadingOrder && order==null" class="p-3">
        
        <div class="shimmer-wrapper mb-3" style="height: 60px; width: 100%; border-radius: 8px;"></div>
        <div class="shimmer-wrapper mb-3" style="height: 80px; width: 100%; border-radius: 8px;"></div>
        <div v-for="i in 3" :key="i" class="mb-2">
          <div class="shimmer-wrapper mb-2" style="height: 20px; width: 70%;"></div>
          <div class="shimmer-wrapper" style="height: 14px; width: 40%;"></div>
        </div>

        <div class="shimmer-wrapper my-3" style="height: 50px; width: 100%; border-radius: 8px;"></div>

        <div class="d-flex">
          <div class="shimmer-wrapper mr-2" style="height: 45px; width: 50%; border-radius: 8px;"></div>
          <div class="shimmer-wrapper" style="height: 45px; width: 50%; border-radius: 8px;"></div>
        </div>
      </div>


    <div v-else-if="order" >
      <div v-if="!isArchivedOrder" class="my-2">
          <b-alert
            show
            variant="danger"
            class="text-justify d-flex align-items-center flex-column flex-md-row justify-content-between border border-3 border-danger shadow-lg rounded p-3"
            v-if="this.order && this.order.isCallWaiter && this.order.callWaiterReason"
          >

          <div class="row w-100">
            <div class="col-xxl-8 col-xl-12 col-lg-8 col-sm-12 col-8 d-flex align-items-center mb-2 mb-md-0">
              <img src="@/assets/icons/waiter-j.svg" height="30" class="pr-2" alt="waiter" @click="findCallWaiterReason()" />
              <div class="mb-0">
                <div class="font-weight-bold text-uppercase font-size-14">
                  {{ $t('menuOrder.order.filter.callWaiter') }}
                </div>
                <div class="font-size-14" v-if="order && order.callWaiterReason">
                  {{ order.callWaiterReason }}
                </div>
                <div class="text-muted font-size-12">
                  {{ order.callWaiterFrom }}
                </div>
              </div>
            </div>

            <div class="col-xxl-4 col-xl-12 col-lg-4 col-sm-12 col-4 d-flex justify-content-md-start justify-content-lg-end mt-xxl-0 mt-xl-2 mt-lg-0 mt-sm-2 mt-0">
              <b-button
                id="call-waiter-button"
                variant="danger"
                size="sm"
                class="touch-friendly-btn  btn-lg text-uppercase px-4 py-1 shadow-sm font-weight-bold w-100 w-lg-auto"
                @click="updateStatus(ACTIONS_STATUS.CALL_WAITER)"
              >
                <img alt="check" width="17" src="@/assets/icons/check-circle-white.svg" class="mr-1" />
                Ok !
              </b-button>
            </div>
          </div>

          </b-alert>
        </div>

        <div v-if="submittedUnviewedItems.length > 0" class="new-order-section px-3 py-2 mb-2 rounded bg-white" :class="isArchivedOrder ? 'mt-2' : ''">
          <div class="d-flex align-items-center justify-content-between mb-3">
            <h5 class="text-uppercase mb-0" style="color: rgb(253, 126, 20);">
              {{$t("menuOrder.newOrder")}}
            </h5>

            <b-button class="touch-friendly-btn-viewed text-uppercase font-weight-bold btn-lg px-3 ml-3" variant="success" :disabled="hasNoSubmittedItems || isArchivedOrder"
              @click="updateStatus(ACTIONS_STATUS.VIEWED)">
              <img alt="check" width="20" src="@/assets/icons/check-circle-white.svg" class="mr-2"/> Ok, Reçu !
            </b-button>

          </div>

          <div v-for="(item, index) in submittedUnviewedItems" :key="index" class="mb-3">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <strong class="font-size-14 ">{{ item.cartItemQuantity }} x <span class="ml-1 font-weight-normal"> {{ item.name }}</span></strong>
              </div>
              <div>
                <strong class="text-dark">{{ item.cartItemSubTotal }}</strong>
              </div>
            </div>
            <div v-if="item.note" class="text-danger font-size-12">
              {{ item.note }}
            </div>
            <div v-if="item.submittedFrom" class="text-muted font-size-12">
              {{ item.submittedFrom }}
            </div>

          </div>
        </div>

        <div v-if="submittedViewedItems.length > 0">
          <div class="d-flex align-items-center justify-content-between pt-3">
            <h5 class="text-dark text-uppercase">Commande
            </h5>
            <h6 class="">{{order.submissionDate}}</h6>
          </div>

          <div v-if="!isArchivedOrder">

            <VSelectWithValidation  @item-close="displayMenuItemsList()" :isMobile="this.isMobile"
                    :menuItems="menuItems" v-if="showMenuItmesList && menuItems" class="mb-3 mt-3" @item-selected="handleItemSelected"  />
            
            <div v-else class="mt-2 mb-2 text-muted text-right" style="cursor: pointer;" @click="displayMenuItemsList()"> Ajouter un Article
              <img alt="ajouter un article" height="20" class="ml-2 icon-btn"  src="@/assets/icons/add-p.svg" style="cursor: pointer;" />
            </div>

          </div>

          <div v-for="(item, index) in submittedViewedItems" :key="index" class="mb-3">
            <div  class="d-flex flex-wrap justify-content-between align-items-center">
              <div  class="d-flex align-items-center flex-wrap">
                <QuantityControl
                  v-if="lineEditingQuantityId === item.orderLineId && !isArchivedOrder"
                  :item="item"
                  :quantity="item.cartItemQuantity"
                  :iconSize="16"
                  :fontSize="16"
                  :btnSize="25"
                  :manualInput="false"
                  :addToOrderAuto="false"
                  @updateQuantity="(newQty) => handleQuantityChange(newQty, item)"
                  v-click-outside="() => cancelEditingQuantity(item.orderLineId)"
                />

                <strong
                  class="font-size-14 d-inline-block item-name"
                  :class="{ expanded: expandedItemId === item.orderLineId , quantityControl: lineEditingQuantityId === item.orderLineId}"
                  @click="toggleExpand(item.orderLineId)"
                >
                  <span v-if="lineEditingQuantityId !== item.orderLineId" >{{ item.cartItemQuantity }}×</span>
                  <span class="ml-1 font-weight-normal" :title="item.name">{{ item.name }}</span>
                </strong>

              </div>

              <div v-if="!isArchivedOrder" class="d-flex align-items-center  mt-1 mt-sm-0 text-nowrap">
                <strong>{{ item.cartItemSubTotal }}</strong>
                <img
                  alt="trash"
                  height="20"
                  class="ml-2 icon-btn"
                  src="@/assets/icons/trash.svg"
                  style="cursor: pointer;"
                  @click="handleQuantityChange(0, item)"
                />
                <img
                  alt="Edit"
                  width="17"
                  class="ml-2 icon-btn"
                  src="@/assets/icons/pencil.svg"
                  style="cursor: pointer;"
                  @click="editingQuantity(item.orderLineId)"
                />
              </div>
            </div>
            <div v-if="item.note" class="text-danger font-size-12 mt-1">
              {{ item.note }}
            </div>
          </div>
        </div>

        <div class="w-100 mt-2" v-if="submittedItems && submittedItems.cartTotalAsFloat > 0">
          <div class="d-flex justify-content-between align-items-center p-4 rounded shadow-sm bg-light ">
            <span class="text-uppercase font-weight-bold text-info total-label">{{$t("menuOrder.order.total")}}</span>
            <span class="font-weight-bold text-dark total-amount total-label">{{ submittedItems.cartTotal }}</span>
          </div>
        </div>

        <div v-if="this.order" class="row mt-3">
          <div class="mb-2" :class="isArchivedOrder ? 'col-12' : 'col-6 pr-2' ">

            <div class="row">
              <div :class="isArchivedOrder ? 'col-12' : 'col-6' ">
                  <b-button
                    variant="light"
                    class="touch-friendly-btn btn-lg  w-100 h-100 text-uppercase m-0  px-0 py-2 font-weight-bold mr-2"
                    @click="showReceiptModal = !showReceiptModal"
                  >
                  <img alt="print" class="ml-2" width="25px" src="@/assets/icons/print.svg" style="cursor: pointer;"  />
                </b-button>
              </div>
              <div v-if="!isArchivedOrder" class="col-6">
                <b-button
                  variant="light"
                  class="touch-friendly-btn btn-lg  w-100 h-100 text-uppercase m-0  px-0 py-2 font-weight-bold ml-2"
                  @click="updateStatus(ACTIONS_STATUS.CANCEL)"
                >
                  <img alt="print" class="ml-2" width="25px" src="@/assets/icons/close-danger.svg" style="cursor: pointer;" />
                </b-button>
              </div>
            </div>


          </div>
          <div v-if="!isArchivedOrder" class="col-6 mb-2 pl-2">
            <b-button
              variant="danger"
              class="touch-friendly-btn btn-lg  w-100 h-100 text-uppercase m-0 font-weight-bold px-0 py-2"
              @click="updateStatus(ACTIONS_STATUS.ARCHIVED)"
            >
              {{ $t('menuOrder.order.button.archived') }}
            </b-button>
          </div>
        </div>
    </div>

    <div v-else class="text-center mt-4 p-4 bg-light rounded shadow-sm">
      <div class="mb-3">
        <img src="@/assets/images/Spoon-fork-knife-icon.png" alt="no-order" width="180" />
      </div>
      <h5 class="text-info font-weight-bold text-uppercase mb-2">
        {{ $t('menuOrder.order.noOrdersTitle') }}
      </h5>
      <p class="text-muted mb-0">
        {{ $t('menuOrder.order.noOrdersDescription') }}
      </p>
    </div>


    
    <b-modal
    style="  position: fixed;
  overflow: hidden;"
      v-model="showReceiptModal"
      hide-footer
      hide-header
      centered
      size="md">
      <Receipt :order="this.order" />
    </b-modal>

    

  </div>
</template>

<style scoped>

.total-label {
  letter-spacing: 0.12em;
  font-size: 1.1rem;

}

.total-amount {
  font-size: 1.2rem;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

</style>


<style scoped>
.touch-friendly-btn {
  border-radius: 2px;
  font-size: 16px;
}

.touch-friendly-btn-viewed-p {
  border-radius: 2px;
  background-color: #28a745;
  border: 1px solid #28a745;
}

.touch-friendly-btn-viewed {
  border-radius: 2px;
  background-color: rgb(253, 126, 20);
  border: 1px solid rgb(253, 126, 20);
}

.new-order-section {
  box-shadow: 0 0 10px rgb(253, 126, 20);
  border: 1px solid rgb(253, 126, 20);
  animation: pulse 3s infinite;
}

@keyframes pulse {
  0% { box-shadow: 0 0 5px rgb(245, 216, 176); }
  50% { box-shadow: 0 0 15px rgb(253, 126, 20); }
  100% { box-shadow: 0 0 5px rgb(245, 216, 176); }
}

.viewed-order-section {
  opacity: 0.85;
}
 
.item-name {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  max-width: 180px;
}

.item-name.quantityControl {
  max-width: 140px;
}


@media (min-width: 768px) and (max-width: 878px) {
  .item-name {
    max-width: 140px;
  }
  .item-name.quantityControl {
    max-width: 100px;
  }
}

@media (min-width: 1200px) and (max-width: 1299px) {
  .item-name {
    max-width: 135px;
  }
  .item-name.quantityControl {
    max-width: 90px;
  }
}

@media (min-width: 1300px) and (max-width: 1450px) {
  .item-name {
    max-width: 160px;
  }
  .item-name.quantityControl {
    max-width: 120px;
  }
}

@media (min-width: 1451px) and (max-width: 1499px) {
  .item-name {
    max-width: 190px;
  }
  .item-name.quantityControl {
    max-width: 150px;
  }
}

@media (min-width: 1500px) and (max-width: 1699px) {
  .item-name {
    max-width: 210px;
  }
  .item-name.quantityControl {
    max-width: 170px;
  }
}

@media (min-width: 1700px) {
  .item-name {
    max-width: 260px;
  }
  .item-name.quantityControl {
    max-width: 220px;
  }
}


.item-name.expanded {
  white-space: normal;
  overflow: visible;
}

@media (max-width: 576px) {
  .icon-btn {
    width: 16px !important;
    height: auto !important;
  }
}

</style>




<style>
.shimmer-wrapper {
  position: relative;
  overflow: hidden;
  background: #e0e0e0;
  border-radius: 6px;
}

.shimmer-wrapper::after {
  content: "";
  position: absolute;
  top: 0;
  left: -150px;
  width: 150px;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent);
  animation: shimmer 1.2s infinite;
}

@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}

.custom-vselect .vs__dropdown-toggle {
  font-size: 12px;
  color: #121212;
  background-color: #f5f5f5;
  border-radius: 4px;
  padding: 2px 5px;
}

.custom-vselect .vs__dropdown-menu {
  font-size: 12px;
}


</style>


<style>

.swal-item-name {
  text-transform: uppercase !important;
  font-weight: 400 !important;
  margin-top: 0.2rem !important;
  font-size: 1.1rem !important;
  color: #000;
}

.swal-modern-popup {
  padding: 2rem !important;
  border-radius: 18px !important;
  background: #ffffff !important;
  box-shadow: 0 8px 40px rgba(0,0,0,0.08) !important;
}

.swal-modern-title {
  font-size: 1.4rem !important;
  font-weight: 400 !important;
  color: #1a1a1a !important;
}

.swal-desc {
  font-size: 0.85rem !important;
  color: #4a4a4a !important;
  margin-bottom: 10px !important;
  line-height: 1.3 !important;
}
.swal-modern-input {
  border-radius: 10px !important;
  padding: 10px !important;
  border: 1px solid #ddd !important;
  font-size: 1rem !important;
}

.swal-btn-confirm {
  background-color: #28a745 !important;
  color: white !important;
  border-radius: 8px !important;
  padding: 10px 18px !important;
  font-weight: 600 !important;
  border: none !important;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.1s;
}

.swal-btn-confirm:hover {
  background-color: #218838 !important;
  transform: translateY(-1px);
}

.swal-btn-confirm:active {
  transform: translateY(1px);
}

.swal-btn-cancel {
  background: transparent !important;
  color: #666 !important;
  border: 1px solid #ddd !important;
  border-radius: 8px !important;
  padding: 10px 18px !important;
  font-weight: 500 !important;
}

.swal2-icon-content i {
  font-size: 32px;
  color: #111;
}

</style>


<style>


.transfer-input {
  border-radius: 12px;
  font-size: 14px;
  padding: 12px;
}

.step-btn {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.step-btn:active {
  transform: scale(0.9);
  background-color: #e0e0e0;
}


</style>